import React from "react";
import withRouter from "../functional-hook-wrapper";
import { useCmsSection } from "@/hooks/useCmsContent";
import Editable from "@/components/cms/Editable";
import styles from './navigation-banner.module.css';

function NavigationBannerInner({ router }: { router: any }) {
    const isLoggedIn = localStorage.getItem('token')?.length;
    const { fields, refetch } = useCmsSection('home', 'banner', {
        text: 'Kwik Fill Giveaway!',
        link: '/win',
    });

    const getWelcomeMessage = () => {
        const name = localStorage.getItem('first_name');
        return name ? `Welcome, ${name}` : 'Welcome';
    };

    const navigateTo = (path: string) => {
        window.history.pushState({}, '', path);
        router.navigate(path);
    };

    return (
        <div className={styles.container}>
            <div className={styles.left}>
                <div className={styles.left_inner}>
                    <Editable page="home" section="banner" field="text" value={fields.text}>
                        <div style={{cursor: 'pointer'}} onClick={() => router.navigate(fields.link)}>{fields.text}</div>
                    </Editable>
                </div>
            </div>

            { isLoggedIn ?
            <>
                <div className={styles.right}>
                    <div onClick={() => navigateTo('/kwikpay')} className={styles.navigation_item} style={{marginRight: 20}}>
                        <img className={styles.card_icon} style={{ display: 'inline-block', marginRight: 8, transform: 'translateY(4px)' }} src={`${process.env.PUBLIC_URL}/assets/navigation/credit-card.svg`} alt=""/>
                        KwikPAY
                    </div>
                    <div onClick={() => navigateTo('/careers')} className={styles.navigation_item} style={{marginRight: 24}}>Careers</div>
                    <div onClick={() => navigateTo('/stores')} className={styles.navigation_item} style={{marginRight: 24}}>Find a Store</div>
                    <div onClick={() => navigateTo('/account')} className={styles.navigation_welcome}>{getWelcomeMessage()}</div>
                </div>

                <div onClick={() => { localStorage.clear(); window.location.href = '/'; }} className={styles.sign_in}>
                    Sign Out
                </div>
            </>
            :
            <>
                <div className={styles.right}>
                    <div onClick={() => navigateTo('/kwikpay')} className={styles.navigation_item} style={{marginRight: 24}}>
                        <img className={styles.card_icon} style={{ display: 'inline-block', marginRight: 8, transform: 'translateY(4px)' }} src={`${process.env.PUBLIC_URL}/assets/navigation/credit-card.svg`} alt=""/>
                        KwikPAY
                    </div>
                    <div onClick={() => navigateTo('/careers')} className={styles.navigation_item} style={{marginRight: 24}}>Careers</div>
                    <div onClick={() => navigateTo('/stores')} className={styles.navigation_item} style={{marginRight: 24}}>Find a Store</div>
                    <div onClick={() => navigateTo('/account/register')} className={styles.navigation_item} style={{marginRight: 0}}>Register</div>
                </div>

                <div onClick={() => navigateTo('/account/login')} className={styles.sign_in}>
                    Sign In
                </div>
            </>
            }
        </div>
    );
}

// Wrap with router HOC to maintain compatibility with class-based parent components
export class NavigationBanner extends React.Component {
    router: any;
    constructor(props: any) {
        super(props);
        this.router = props.router;
    }
    render() {
        return <NavigationBannerInner router={this.router} />;
    }
}

export default withRouter(NavigationBanner);
